import React from 'react';
import {ContextDataStore} from "../../common/helpers/HelperGlobalDataStore";
import BaseComponent from "../../common/BaseComponent/BaseComponent";


class ComponentSocials extends BaseComponent {

	constructor() {
		super(...arguments, 'ComponentSocials');
	}

	/**
	 * От React 16.4, 'componentWillReceiveProps' е deprecated.
	 * Вместо нея се използва 'getDerivedStateFromProps'.
	 * Тази функция се извиква винаги, когато се смени state-a или props-a.
	 * Това става както при Mounting-а на компонента, така и след зареждането на данните с AJAX при
	 * lazyLoading-a. Този метод се използва вместо componentWillReceiveProps.
	 */
	render() {
		let dataSocials = this.context.get(this.componentName);
		/*
		 * Проверка дали е инициализирана контролата с props.
		 */
		if (!dataSocials) {
			return null;
		}
		let data = dataSocials.componentData;
		if (!data) {
			return null;
		}

		// nume
		if(typeof sh_set_nm_internal === 'function'){
			sh_set_nm_internal(Number(data.internal))
		}

		if(typeof sh_set_nm_customer === 'function' && data.clientId !== ''){
			sh_set_nm_customer(data.clientId);
		}

		if(typeof sh_set_nm_cart === 'function' && data.numeCartState){
			sh_set_nm_cart(data.numeCartState);
		}

		if(typeof sh_start_nm === 'function' && data.auto_start_nume) {
			sh_start_nm();
		}

		/**
		 * Инициализация на JS ValueObject с данни (JSON обект), които ще се подават към зареденият външен JS файл.
		 * Подават се през window обекта на браузера.
		 * Данните са инициализирани от PHP component-a, могат да се добавят и други тук към JSON обекта.
		 * Тука може да се добавят custom данни в JSON обекта;
		 */

		window.shSocialParamVO = data;

		if (typeof trackEvents === 'function') {
			trackEvents();
		}

		/**
		 * Глобален флаг, дали вече е зареден външният ресурс.
		 * Гаранитра, че външният файл ще се зареди само 1 път.
		 */
		if (window.shSocialFileLoaded) {
			return null;
		}
		try {
			window.loadTagManager = true;
			window.shSocialFileLoaded = true;


			/**
			 * Зарежда външният JS файл.
			 */
			const script = document.createElement("script");

			script.src = "/js/sh_social_scripts.js";
			script.async = true;

			document.body.appendChild(script);

			window.SH_SITE_INCLUDE_HOTJAR = false;
			if (data.includeHotJar) {
				window.SH_SITE_INCLUDE_HOTJAR = true;

				/** Зареждаме и hotjar JS файла-а */
				/** Ще го зареждаме през tag manager-a*/
				//const scriptHJ = document.createElement("script");

				//scriptHJ.src = "/js/hotjar.js";
				//scriptHJ.async = true;

				//document.body.appendChild(scriptHJ);
			}


		} catch (e) {
			console.error(e);
		}
		return null;
	}

}

// React Context binding
ComponentSocials.contextType = ContextDataStore;


export default ComponentSocials;
